import type { Lang } from "./i18n";

// Какие SSO-провайдеры показывать на каждой версии. Бэкенд один на оба хоста
// и отдаёт общий список, поэтому режем на клиенте. RU-версия по закону об
// авторизации (149-ФЗ, с 01.12.2023) может пускать пользователей только через
// российские сервисы — Google/GitHub там показывать нельзя. На tech-версии
// наоборот: Яндекс не нужен.
export function ssoProviderAllowlist(lang: Lang): ReadonlySet<string> {
  return lang === "ru"
    ? new Set(["yandex"])
    : new Set(["google", "github"]);
}
